import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import CardHeader from "@mui/material/CardHeader";
import { TextField } from "@material-ui/core";
import {
  verifyFirstLogin,
  isSessionExpired,
  setSessionActive,
  clearStoragePortal,
  setPasswordFull,
  setPasswordDefault,
  verifyPermission,
} from "../../api/services/AuthService";
import Alert from "@mui/material/Alert";
import back from "../../../assets/images/back.jpg";
import { Link, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../theme/Theme";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import AirlinesIcon from "@mui/icons-material/Airlines";
import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import styled from "styled-components";

import LoginService from "../../api/services/LoginService";

const DivLogin = styled.div`
  background: linear-gradient(135deg, #040138 0%, #0a0a4f 100%);
   min-height: 100vh; /* 👈 chave */ 
   width: 100%; 
   display: flex; 
   flex-direction: column; 
   align-items: center; 
   justify-content:center; 
   padding: 60px 40px; 
   position: relative;  
     &:before { 
        content: "";
         position: absolute; 
         inset: 0; 
         background: url(${back}); 
         background-size: cover; 
         background-position: top center; 
         z-index: 0;
     }
`;

const CardLogin = styled(Card)`
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.4) !important;
  margin: 0 auto;
  width: 550px;
  opacity: 0.8;
`;

const Titulo = styled(Typography)`
  z-index: 2;
  color: white;
  font-weight: 600;
  margin-bottom: 30px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    color: white;
  }
`;

const LinkMenu = styled(Link)`
  color: ##0a0a4f !important;
  text-decoration: none;
  font-size: 0.9rem;

  &:hover {
    color: white;
    text-decoration: underline;
  }
`;

const CardHeaderLogin = styled(CardHeader)`
  background: transparent !important;

  .MuiCardHeader-title {
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 1px;
  }
`;

const ButtonLogin = styled(Button)`
  background: linear-gradient(135deg, #0a0a4f, #2729b4) !important;
  color: white !important;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none !important;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(23, 15, 182, 0.5);
    background: linear-gradient(135deg, #2729b4, #0a0a4f) !important;
  }
`;

const AlertBadCredentials = styled(Alert)`
  margin-bottom: 5px;
  display: ${({ isvisible }) =>
    isvisible === "true" ? "flex !important" : "none !important"};
`;
export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [variant, setVariant] = useState("error");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    const statusSessionExpired = () => {
      setVariant("warning");
      setMessage("Sessão Encerrada!");
      setError(true);
      clearStoragePortal();
    };
    if (error !== true && isSessionExpired() === true) {
      statusSessionExpired();
    }
  }, [variant, message, error]);

  const servico = new LoginService();

  return (
    <form
      onSubmit={(event) => {
        setOpen(true);
        setError(false);
        event.preventDefault();
        servico
          .autenticar({
            username: username,
            password: password,
          })
          .then((response) => {
            const jsonToken = response.data;
            verifyPermission(jsonToken);
            servico.clearStorage();
            let user = verifyFirstLogin(jsonToken);
            setSessionActive();
            if (user.isReset) {
              setPasswordFull();
              if (user.isAdmin) {
                navigate("/fatura");
                navigate(0);
              } else {
                navigate("/dashboard");
                navigate(0);
              }
            } else {
              setPasswordDefault();
              navigate("/redefinirSenha");
              navigate(0);
            }
          })
          .catch((erro) => {
            setError(true);
            setVariant("error");
            if (erro.code === 401) setMessage(erro.message);
            else {
              switch (erro?.response?.status) {
                case 401 || 403:
                  setMessage("Credenciais Inválidas!");
                  break;
                default:
                  setMessage(
                    "Problema ao tentar logar, entre em contato com o adm do sistema!",
                  );
                  break;
              }
            }
          })
          .finally(() => {
            setOpen(false);
          });
      }}
    >
      <ThemeProvider theme={theme}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <DivLogin>
          <Titulo variant="h3" gutterBottom>
            <AirlinesIcon sx={{ fontSize: 50 }}></AirlinesIcon>PORTAL DO AGENTE
          </Titulo>
          <CardLogin>
            <CardHeaderLogin title="LOGIN" />
            <CardContent>
              <TextField
                id="username"
                autoComplete="off"
                label="Usuário"
                type="text"
                margin="normal"
                variant="outlined"
                fullWidth
                required
                placeholder="Usuário"
                hiddenLabel
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
              />

              <TextField
                id="password"
                autoComplete="off"
                required
                hiddenLabel
                label="Senha"
                name="senha"
                type="password"
                margin="normal"
                placeholder="Senha"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
              <AlertBadCredentials
                isvisible={error.toString()}
                variant="filled"
                severity={variant}
              >
                {message}
              </AlertBadCredentials>
              <Grid
                container
                spacing={2}
                style={{ marginTop: 5, marginBotton: "1em" }}
              >
                <Grid item xs={6}>
                  <ButtonLogin
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Logar
                  </ButtonLogin>
                </Grid>
                <Grid item xs={6}>
                  <LinkMenu to="/recuperarSenha">
                    <ListItem>
                      <ListItemText
                        sx={{ color: "#4682B4", textAlign: "right" }}
                        primary={"Esqueci minha senha"}
                      />
                    </ListItem>
                  </LinkMenu>
                </Grid>
              </Grid>
            </CardContent>
          </CardLogin>
        </DivLogin>
      </ThemeProvider>
    </form>
  );
}
